var _path, _path2, _circle, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStationError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 60,
    viewBox: "0 0 49 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0823 53.7644C24.0552 53.7652 24.028 53.7656 24.0008 53.7656C22.994 53.7656 22.0673 53.218 21.5817 52.3356L8.8691 29.2703L8.86501 29.2627C7.51152 26.7503 6.80078 23.9213 6.80078 21.0672C6.80078 11.56 14.5099 3.81796 24.0008 3.81796C33.4917 3.81796 41.2008 11.56 41.2008 21.0671C41.2008 23.9207 40.4903 26.7497 39.1414 29.2548L39.1372 29.2625L34.4536 37.7601C35.0325 37.6898 35.6387 37.6624 36.2312 37.7152C36.3934 37.7297 36.5607 37.7507 36.7309 37.7803L40.8898 30.2347L40.8987 30.2182C42.4073 27.4165 43.2008 24.256 43.2008 21.0671C43.2008 10.4346 34.5854 1.80005 24.0008 1.80005C13.4161 1.80005 4.80078 10.4347 4.80078 21.0672C4.80078 24.2573 5.59468 27.4176 7.10781 30.2263L7.11651 30.2425L19.8343 53.3173C20.6759 54.8446 22.2744 55.7835 24.0008 55.7835C24.3598 55.7835 24.7128 55.743 25.0546 55.6651C24.642 55.017 24.3236 54.3734 24.0823 53.7644Z",
    fill: "#F59D0E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.25 20.25C28.25 22.5972 26.3472 24.5 24 24.5C21.6528 24.5 19.75 22.5972 19.75 20.25C19.75 17.9028 21.6528 16 24 16C26.3472 16 28.25 17.9028 28.25 20.25Z",
    stroke: "#F59D0E",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 35.5,
    cy: 49.5,
    r: 9.5,
    stroke: "#E82626",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2911 45.1508L35.2564 51.7152C35.2581 51.7266 35.2745 51.7266 35.2762 51.7152L36.2416 45.1508C36.3291 44.5557 35.8678 44.0216 35.2663 44.0216C34.6648 44.0216 34.2035 44.5557 34.2911 45.1508Z",
    fill: "#E82626",
    stroke: "#E82626",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1816 54.5501C36.1816 55.0544 35.7728 55.4632 35.2685 55.4632C34.7643 55.4632 34.3555 55.0544 34.3555 54.5501C34.3555 54.0459 34.7643 53.6371 35.2685 53.6371C35.7728 53.6371 36.1816 54.0459 36.1816 54.5501Z",
    fill: "#E82626"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStationError);
export default __webpack_public_path__ + "static/media/StationError.b885465dab27041e8622db31f72cd56a.svg";
export { ForwardRef as ReactComponent };